import { ClassMethod } from '@angular/compiler';

// data for 3D object definition for BioDigital Human Module files
const EPS = 1e-4;

export class HumanObjectRenderable {
    geometryId?: string;
    materialId?: string;
    morphId?: string;
    layer?: number;
}

export class EuclideanData {
    x?: number;
    y?: number;
    z?: number;
}

export class HumanObjectTransform {
    translate?: EuclideanData;
    rotate?: EuclideanData;
    scale?: EuclideanData;
    pivot?: EuclideanData;

    // filter EuclideanData in place and return empty/fill status
    // TODO: implementation details should not be included in the contract.
    private filterEuclidean(data: EuclideanData, target: number = 0): void {
        ['x', 'y', 'z'].forEach((dimension) => {
            if (Math.abs(data[dimension] - target) < EPS) {
                delete data[dimension];
            }
        }, this);

    }

    // filter out transform properties at identity
    filter() {
        // filter out identity transorms at 0
        ['translate', 'rotate', 'pivot'].forEach((transform) => {
            this.filterEuclidean(this[transform]);
            if (Object.keys(this[transform]).length === 0) {
                delete this[transform];
            }
        }, this);

        // filter out identity transforms at 1
        this.filterEuclidean(this.scale, 1.0);
        if (Object.keys(this.scale).length === 0) {
            delete this.scale;
        }
    }
}

export class SceneGraphNode {
    objectId: string;
    displayName: string;
    layer: number;
    objects?: SceneGraphNode[];
    transformId?: string;
    geometryId?: string;
    materialId?: string;
    renderables?: HumanObjectRenderable[];
    backfaces?: boolean;
    transform?: HumanObjectTransform;
}
